import {
  string, bool, shape, node, func,
} from 'prop-types';

import nothingHereLight from '../../images/nothing-here.png';
import nothingHereDark from '../../images/nothing-here-dark.png';

export const lightTheme = {
  isLight: true,
  bgMain: '#F2F2F2',
  bgSidebar: '#373B53',
  bgForm: 'linear-gradient(#FFFFFF 40%, #F2F2F2 80%);',
  bgInput: '#FFF',
  bgInvoice: '#FFF',
  bgBtnContainer: '#FFF',
  bgInvoiceItems: '#F9FAFE',
  bgInvoiceItemsFooter: '#373B53',
  colorPrimary: '#0C0E16',
  colorSecondary: '#7E88C3',
  colorInput: '#000000',
  colorInputLabel: '#7C5DFA',
  colorName: '#858BB2',
  colorTotal: '#888EB0',
  nothingHere: nothingHereLight,
  button: {
    newInvoice: {
      background: '#7C5DFA',
      hover: '#9277FF',
      color: '#FFF',
      width: (isMobile) => (isMobile ? '90px' : '150px'),
    },
    markAsPaid: {
      background: '#7C5DFA',
      color: '#FFF',
      hover: '#9277FF',
      width: (isMobile) => (isMobile ? '149px' : '131px'),
    },
    edit: {
      background: '#F9FAFE',
      color: '#7E88C3',
      hover: '#DFE3FA',
      width: () => '73px',
    },
    discard: {
      background: '#F9FAFE',
      color: '#7E88C3',
      hover: '#DFE3FA',
      width: (isMobile) => (isMobile ? '84px' : '96px'),
    },
    saveAsDraft: {
      background: '#373B53',
      color: '#888EB0',
      hover: '#0C0E16',
      width: (isMobile) => (isMobile ? '117px' : '133px'),
    },
    saveChanges: {
      background: '#7C5DFA',
      color: '#FFF',
      hover: '#9277FF',
      width: () => '138px',
    },
    saveAndSend: {
      background: '#7C5DFA',
      color: '#FFF',
      hover: '#9277FF',
      width: (isMobile) => (isMobile ? '112px' : '128px'),
    },
    delete: {
      background: '#EC5757',
      color: '#FFF',
      hover: '#FF9797',
      width: () => '89px',
    },
    addNewItem: {
      background: '#F9FAFE',
      color: '#7E88C3',
      hover: '#DFE3FA',
      width: (isMobile) => (isMobile ? '327px' : '504px'),
    },
    cancel: {
      background: '#F9FAFE',
      color: '#7E88C3',
      hover: '#DFE3FA',
      width: () => '96px',
    },
  },
};

export const darkTheme = {
  isLight: false,
  bgMain: '#141625',
  bgSidebar: '#1E2139',
  bgInvoice: '#1E2139',
  bgForm: '#252945',
  bgInput: '#1E2139',
  bgBtnContainer: '#1E2139',
  bgInvoiceItems: '#252945',
  bgInvoiceItemsFooter: '#0C0E16',
  colorPrimary: '#FFF',
  colorSecondary: '#DFE3FA',
  colorName: '#DFEFA',
  colorInput: '#FFF',
  colorInputLabel: '#DFE3FA',
  colorTotal: '#FFF',
  nothingHere: nothingHereDark,
  button: {
    newInvoice: {
      background: '#7C5DFA',
      hover: '#9277FF',
      color: '#FFF',
      width: (isMobile) => (isMobile ? '90px' : '150px'),
    },
    markAsPaid: {
      background: '#7C5DFA',
      color: '#FFF',
      hover: '#9277FF',
      width: (isMobile) => (isMobile ? '149px' : '131px'),
    },
    edit: {
      background: '#252945',
      color: '#DFE3FA',
      hover: '#fff',
      width: () => '73px',
    },
    saveAsDraft: {
      background: '#373B53',
      color: '#888EB0',
      hover: '#0C0E16',
      width: (isMobile) => (isMobile ? '117px' : '133px'),
    },
    saveChanges: {
      background: '#7C5DFA',
      color: '#FFF',
      hover: '#9277FF',
      width: () => '133px',
    },
    saveAndSend: {
      background: '#7C5DFA',
      color: '#FFF',
      hover: '#9277FF',
      width: (isMobile) => (isMobile ? '112px' : '128px'),
    },
    delete: {
      background: '#EC5757',
      color: '#FFF',
      hover: '#FF9797',
      width: () => '89px',
    },
    addNewItem: {
      background: '#1E2139',
      color: '#FFF',
      hoverColor: '#888EB0',
      width: (isMobile) => (isMobile ? '327px' : '504px'),
    },
    discard: {
      background: '#F9FAFE',
      color: '#7E88C3',
      hover: '#DFE3FA',
      width: (isMobile) => (isMobile ? '84px' : '96px'),
    },
    cancel: {
      background: '#F9FAFE',
      color: '#7E88C3',
      hover: '#DFE3FA',
      width: () => '96px',
    },
  },
};

export const themePropType = {
  isLight: bool.isRequired,
  bgMain: string.isRequired,
  bgSidebar: string.isRequired,
  bgInvoice: string.isRequired,
  bgForm: string.isRequired,
  bgInput: string.isRequired,
  bgBtnContainer: string.isRequired,
  colorPrimary: string.isRequired,
  colorSecondary: string.isRequired,
  colorName: string.isRequired,
  colorInput: string.isRequired,
  colorInputLabel: string.isRequired,
  colorTotal: string.isRequired,
  nothingHere: node.isRequired,
  button: shape({
    newInvoice: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    markAsPaid: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    edit: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    saveAsDraft: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    saveChanges: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    saveAndSend: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    delete: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    addNewItem: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    discard: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
    cancel: {
      background: string.isRequired,
      hover: string.isRequired,
      color: string.isRequired,
      width: func.isRequired,
    },
  }).isRequired,
};
